module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 8 6.8",
      url: __webpack_public_path__ + "img/icons.116e467f.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }